import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { Customer } from '../customer/Customer';
import { CapitalNeeds } from './CapitalNeeds';

@supertypeClass({ toClient: true, toServer: true })
export class CashFlow extends Everything {
  @property({ values: { perm: 'Permanent', term: 'Term', work: 'Work' } })
  type: string;

  @property()
  bucket: string;

  @property()
  subtype: string;

  @property()
  title: string;

  @property({ rule: ['currency'], validate: 'isWithin(0, 10000000)' })
  amount: number;

  @property()
  maxGroup: string;

  @property({ getType: () => Customer })
  customer: Customer;

  @property({ getType: () => CapitalNeeds })
  capitalNeeds: CapitalNeeds;

  @property({ isLocal: true, toServer: false })
  flow: { amount: number; startYear: number; endYear: number };

  constructor() {
    super();
  }

  static new(customer, type, subtype, amount?, title?) {
    return new CashFlow().init(customer, type, subtype, amount, title);
  }

  init(customer, type, subtype, amount?, title?) {
    this.customer = customer;
    this.type = type;
    this.subtype = subtype || '';
    this.amount = amount || 0;
    this.title = title || '';
    return this;
  }

  inCashFlow() {
    return true;
  }

  isActive() {
    return this.amount !== 0;
  }

  isIncome() {
    return this.type === 'income';
  }

  getDescription() {
    return this.title;
  }

  getEndYear(deceased?) {
    return this.customer.capitalNeeds.getLastYear(deceased);
  }

  getStartYear() {
    return 0;
  }

  getFlow(deceased, yearOfDeath) {
    yearOfDeath = yearOfDeath ? yearOfDeath : 0;

    const amounts = [];

    this.flow = this.getStartingFlow(deceased, yearOfDeath);

    for (let year = 0; year < this.customer.capitalNeeds.getLastYear(deceased); ++year) {
      amounts[year] = Math.floor(this.getAmount(this.flow, year, deceased, yearOfDeath));
      this.adjustFlow(this.flow, year, deceased);
    }

    return {
      amounts: amounts,
      details: this.flow,
    };
  }

  getStartingFlow(deceased, yearOfDeath?) {
    return {
      amount: this.amount,
      startYear: this.getStartYear(),
      endYear: this.getEndYear(deceased),
    };
  }

  adjustFlow(_flow, _year, _deceased) {}

  getAmount(flow, year, _deceased, yearOfDeath) {
    if (year < yearOfDeath) {
      return 0;
    }

    return year >= flow.startYear && year <= flow.endYear ? flow.amount : 0;
  }
}
